import { Params } from "react-router-dom";
import { EndPointPath, getEndpoints } from "./RouteTypes";
import { customerPathFromSignature } from "@timeedit/registration-shared";

export function isValidBasePath(
  path: string,
  endpoints: ReturnType<typeof getEndpoints>,
  customerSignature: string
): path is EndPointPath {
  const customerPath = customerPathFromSignature(customerSignature);
  const endpointPaths = Object.values(endpoints).map(
    (endpoint) => `${customerPath}/${endpoint.path}`
  );

  return [...endpointPaths, customerPath].includes(path as EndPointPath);
}

interface PathParameters {
  path: string;
  params: Readonly<Params<string>>;
}

export function removePathParameters({ params, path }: PathParameters): string {
  const segments = path.split("/");
  const paramValues = Object.values(params);
  const newSegments = segments.filter(
    (segment) => !paramValues.includes(segment)
  );

  return newSegments.join("/");
}

export function removeFirstLastBackslash(s: string): string {
  return s.replace(/^\/|\/$/g, "");
}
